<div id="coordinator-list-popup" class="coordinator-popup">
    <div class="popoup-hearder">
        <h2 class="m-b-5" mat-dialog-title>Crear coordinador</h2>
    </div>
    <form class="form" role="form" autocomplete="off" [formGroup]="addDoctorForm">
        
        <div class="popoup-content">
            <div class="block-looper-wrapper">
                <div class="block-looper">
                    <div class="form-wrap full-width">
                        <mat-label class="label">Nombre</mat-label>
                        <mat-form-field class="example-full-width" appearance="fill">
                            <input matInput type="text" maxlength="20"  formControlName="Nombre">
                        </mat-form-field>
                        <mat-error
                        *ngIf="addDoctorForm.get('Nombre').invalid && addDoctorForm.get('Nombre').touched">
                        <span *ngIf="addDoctorForm.get('Nombre').hasError"> El nombre es obligatorio</span>
                        </mat-error>
                        <!-- <mat-error class="m-t--15">
                              <span class="validation-span font-88">El nombre es obligatorio</span>
                        </mat-error> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="popoup-footer">
            <button class="keep" (click)="onSave()"><span class="mat-button-wrapper">Guardar</span></button>
            <button class="cancel" (click)="onClose(0)"><span class="mat-button-wrapper">Cancelar</span></button>
        </div>
    </form>
</div>